// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610091039/js/" + chunkId + "." + {"44":"291faac4","225":"395ec7d0","481":"e58f4edf","486":"c51b25ab","770":"a09ac90a"}[chunkId] + ".0.4909297023589042.chunk.js";
};